import React, { useRef, useState, useEffect, useMemo} from 'react';

import CustomSwiper from '../components/Swiper/Swiper';

const GuiaTuristica = () => {

  return (
    <div style={{"text-align": "center", "padding": "4rem 2rem 4rem 2rem"}}>

      <div className="header-seccion">
        <h1 className='bold'>
            Brújula de favoritos
        </h1>
        <p className='text-md'>
            Sabemos el esfuerzo que hacen por estar aquí y queremos que este viaje sea inolvidable para ustedes también.<br/> Nuestra boda es el pretexto ideal para que descubran la magia de esta tierra; por ello, elegimos algunos rincones y sabores emblemáticos que no pueden perderse.
            ¡Desliza👉 la imagen de abajo para verlos!
            <br></br><br></br>
            <p className="text-lg text-cursiva">¡Contamos los días para vernos por acá!</p>
        </p>
      </div>
        
        <CustomSwiper/>
    </div>
  );
};

export default GuiaTuristica;
